// Redux
import { Dispatch } from 'redux';

// Action Creators
import { determineUserBrowserAndVersion } from 'Utils/determineUserBrowserAndVersion';
import {
  setEventListenerHasBeenAttached,
  setGoodDataEvent,
  setPlatformInfoEvent,
  setFilterValueChangeEvent,
  setUIDrillEvent,
  setDateRange,
  setUserBrowser,
} from '../actionCreators/goodData.actionCreators';

// Utilities

/**
 * @function setEventListenerHasBeenAttached
 *
 * Sets the event listeners attach state globally to avoid memory leaks
 * and flooding network calls
 *
 * @param {Dispatch} dispatch - Dispatch
 * @param {boolean} value - Whether the event listener was attached or not
 * of the Demographics filter section.
 * @return {boolean} - Doesn't return in the conventional
 * sense but instead dispatched an action using the function of a
 * similar name to the action-creator that will propogate this information
 * to the Redux store.
 *
 * @example
 *
 *     setEventListenerHasBeenAttachedValue(dispatch, true)
 */
export const setPlatformInfoEventValue = (
  dispatch: Dispatch<any>,
  value: boolean
) => {
  dispatch(setPlatformInfoEvent(value));
};

export const setGoodDataEventValue = (dispatch: Dispatch<any>, value: any) => {
  dispatch(setGoodDataEvent(value));
};

export const setEventListenerHasBeenAttachedValue = (
  dispatch: Dispatch<any>,
  value: boolean
) => {
  dispatch(setEventListenerHasBeenAttached(value));
};

export const setFilterValueChangeEventValue = (
  dispatch: Dispatch<any>,
  value: boolean
) => {
  dispatch(setFilterValueChangeEvent(value));
};

export const setUIDrillEventValue = (
  dispatch: Dispatch<any>,
  value: boolean
) => {
  dispatch(setUIDrillEvent(value));
};

export const setDateRangeValue = (
  dispatch: Dispatch<any>,
  value: {
    selection: {
      label: string;
      value: number;
    };
    fromDate: string;
    toDate: string;
  }
) => {
  dispatch(setDateRange(value));
};

export const setUserBrowserValue = (dispatch: Dispatch<any>) => {
  dispatch(setUserBrowser(determineUserBrowserAndVersion()));
};
try {
    // @ts-ignore
    setUserBrowserValue.displayName = "setUserBrowserValue";
    // @ts-ignore
    setUserBrowserValue.__docgenInfo = { "description": "", "displayName": "setUserBrowserValue", "props": { "apply": { "defaultValue": null, "description": "Calls the function, substituting the specified object for the this value of the function, and the specified array for the arguments of the function.\n@param thisArg The object to be used as the this object.\n@param argArray A set of arguments to be passed to the function.", "name": "apply", "required": true, "type": { "name": "(this: Function, thisArg: any, argArray?: any) => any" } }, "call": { "defaultValue": null, "description": "Calls a method of an object, substituting another object for the current object.\n@param thisArg The object to be used as the current object.\n@param argArray A list of arguments to be passed to the method.", "name": "call", "required": true, "type": { "name": "(this: Function, thisArg: any, ...argArray: any[]) => any" } }, "bind": { "defaultValue": null, "description": "For a given function, creates a bound function that has the same body as the original function.\nThe this object of the bound function is associated with the specified object, and has the specified initial parameters.\n@param thisArg An object to which the this keyword can refer inside the new function.\n@param argArray A list of arguments to be passed to the new function.", "name": "bind", "required": true, "type": { "name": "(this: Function, thisArg: any, ...argArray: any[]) => any" } }, "toString": { "defaultValue": null, "description": "Returns a string representation of a function.", "name": "toString", "required": false, "type": { "name": "() => string" } }, "prototype": { "defaultValue": null, "description": "", "name": "prototype", "required": true, "type": { "name": "any" } }, "length": { "defaultValue": null, "description": "", "name": "length", "required": true, "type": { "name": "number" } }, "arguments": { "defaultValue": null, "description": "", "name": "arguments", "required": true, "type": { "name": "any" } }, "caller": { "defaultValue": null, "description": "", "name": "caller", "required": true, "type": { "name": "Function" } }, "name": { "defaultValue": null, "description": "Returns the name of the function. Function names are read-only and can not be changed.", "name": "name", "required": true, "type": { "name": "string" } }, "__@hasInstance": { "defaultValue": null, "description": "Determines whether the given value inherits from this function if this function was used\nas a constructor function.\n\nA constructor function can control which objects are recognized as its instances by\n'instanceof' by overriding this method.", "name": "__@hasInstance", "required": true, "type": { "name": "(value: any) => boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/GoodData/actions/goodData.actions.ts#setUserBrowserValue"] = { docgenInfo: setUserBrowserValue.__docgenInfo, name: "setUserBrowserValue", path: "src/shared/containers/GoodData/actions/goodData.actions.ts#setUserBrowserValue" };
}
catch (__react_docgen_typescript_loader_error) { }